// src/pages/MenuUpload.tsx
import { useState } from "react";
import api from "../api/axios";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import DashboardTopbar from "../components/DashboardTopbar";

const MenuUpload = () => {
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [price, setPrice] = useState("");
  const [image, setImage] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    setImage(file || null);
    if (file) setPreview(URL.createObjectURL(file));
    else setPreview(null);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!image) return;

    const formData = new FormData();
    formData.append("name", name);
    formData.append("description", desc);
    formData.append("price", price);
    formData.append("image", image);

    try {
      await api.post("/menu-items/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      navigate("/dashboard/menu");
    } catch (err) {
      console.error("Upload failed", err);
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100 text-black">
      <Sidebar />
      <div className="flex flex-col flex-1">
        <DashboardTopbar
          logoUrl="/logo.png"
          name="FullPlateNow Restaurant"
          address="123 Main St, Springfield"
        />
        <main className="p-8 max-w-lg mx-auto">
          <h1 className="text-2xl font-bold mb-6">Upload New Menu Item</h1>
          <form onSubmit={handleSubmit} className="space-y-5">
            <input
              type="text"
              placeholder="Item Name"
              className="w-full px-4 py-2 border rounded"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <textarea
              placeholder="Description"
              className="w-full px-4 py-2 border rounded"
              value={desc}
              onChange={(e) => setDesc(e.target.value)}
              required
            />
            <input
              type="number"
              placeholder="Price"
              className="w-full px-4 py-2 border rounded"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              required
              step="0.01"
            />
            <input type="file" accept="image/*" onChange={handleImageChange} />
            {preview && (
              <img
                src={preview}
                alt="Preview"
                className="h-40 w-full object-cover rounded shadow"
              />
            )}
            <button
              type="submit"
              className="bg-black text-white px-6 py-2 rounded hover:bg-gray-900"
            >
              Upload
            </button>
          </form>
        </main>
      </div>
    </div>
  );
};

export default MenuUpload;
